import styled from "styled-components";

export const Flex = styled.div`
  display: flex;
  gap: 20px;
  width: 100%;
  flex-wrap: wrap;
  margin-bottom: 20px;
`;
